// @ts-nocheck
/* eslint-disable */
export const distanceIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 36 36"><path fill="currentColor" d="M13.04 3.888a6.26 6.26 0 0 0-6.26 6.26V26.14H5.39a1.39 1.39 0 0 0-.982 2.374l2.78 2.781a1.39 1.39 0 0 0 1.968 0l2.78-2.78a1.391 1.391 0 0 0-.982-2.375H9.563V10.147a3.477 3.477 0 1 1 6.954 0v15.3a6.258 6.258 0 0 0 12.517 0v-13.45a4.174 4.174 0 1 0-2.781 0v13.448a3.477 3.477 0 1 1-6.954 0V10.147a6.26 6.26 0 0 0-6.26-6.259"/></svg>`,
    name: 'distance' as const
};